import axios from 'axios'
import isJson from '@/utils/isJson'
async function apiRequest (url) {
  let result
  let status
  await axios.get(url, {
    params: {},
    headers: {
      'Accept-Version': 1,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    status = response.status
    result = response.data || null
  }).catch((error) => {
    status = error.response.status
  })

  // HAS TO BE JSON RESULT
  status = status = (typeof result !== 'undefined' && status >= 200 && status < 300) || false
  status = status ? isJson(result) : false
  return { data: result, status: status }
}

const ACTIONS = {
  async getRequest ({ commit, dispatch, state, getters }, payload) {
    const url = payload.url
    const result = await apiRequest(url)
    return result
  },
  getCached ({ commit, dispatch, state, getters }, payload) {
    const url = payload
    const cached = getters.cacheList(url)
    return cached
  }
}

export default ACTIONS



// WEBPACK FOOTER //
// ./src/store/modules/api/actions.js